// extracted by mini-css-extract-plugin
export default {"noFav":"PeliculasGrid_noFav__TMRR6","peliculasGrid":"PeliculasGrid_peliculasGrid__UeTHv"};